<template lang="pug">
b-container
  .d-flex.flex-column.align-items-start.mb-3
    h4.title Resultados dashboard
    nav.breadcrumb-custom
      span Inicio
      span.separator /
      span Resultados dashboard
  GenericOTList(:tabs="tabs" :otList="otList" :byDashboard="true")
</template>

<script>
import GenericOTList from '../components/OT/ListOT/GenericOTList.vue'

export default {
  name: 'FilteredResultsDashboard',
  components: { GenericOTList },

  data() {
    return {
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { path: '/' },
        },
        {
          text: 'Resultados dashboard',
          active: true,
        },
      ],
      tabs: [
        {
          title: `${this.$route.query.title}`,
          states: Array.isArray(this.$route.query.uniqueStates)
            ? this.$route.query.uniqueStates
            : [this.$route.query.uniqueStates],
        },
      ],
    }
  },

  computed: {
    otList() {
      return this.$route.query.ots.map(ot => Number(ot)).join(',')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.title {
  color: $samtek-black;
  font-size: 22px;
  font-weight: 700;
}

.breadcrumb-custom {
  margin-top: 8px;
  font-size: 15px;
  color: $samtek-grey;
}

.breadcrumb-custom .separator {
  margin: 0 6px;
}
</style>
